import * as React from 'react';

export default class FormValidationService {
    public static getValidationState(value: any): 'success' | 'warning' | 'error' {
        if (value) {
            return 'error';
        }
    }

    public static isEdit(id: any) {
        return id && id > 0;
    }

    public static setTabValidationError(errors: any, ...properties: string[]) {
        if (Object.keys(errors).length === 0) {
            return null;
        }

        let hasErrors = properties.some((prop: string) => {
            return errors[prop] !== undefined;
        });

        return hasErrors ? (
            <i className="material-icons material-icons-danger material-icons-label md-18">error</i>
        ) : null;
    }
}
